import { useContext, useState } from 'react';
import './payment.css';
import { useNavigate } from 'react-router-dom';
import { cartContext } from '../../App';
import HeaderOther from '../ui/header-other';

export default function PaymentPage() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const { CartItem, extraData, clearCart, appliedCoupon, userId, selectedAddress } = useContext(cartContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    const orderValue = CartItem.reduce((sum, item) => sum + Math.round(item.details.price) * item.qty, 0);
    const deliverCharge = Number(orderValue > extraData.data.minOrderValueFee ? 0 : extraData.data.deliveryFee);
    const totalValue = JSON.stringify(appliedCoupon) === '{}' ? orderValue + deliverCharge : orderValue + deliverCharge - appliedCoupon.discountPrice;

    const [selectedOption, setSelectedOption] = useState('Cash On delvery (COD)');
    function handleChange(e) {
        setSelectedOption(e.target.value);
    }

    function placeOrder() {

        if (userId === null) {
            alert('Please log in to place your order!');
            navigate('/login');
        } else if (CartItem.length === 0) {
            alert('No Items in cart!')
        } else {
            const orderNumber = Math.floor(Math.random() * (1000000) + 1) + 1;
            // Convert to local time without AM/PM
            const orderTimeFormatted = new Date()
            const orderTime = orderTimeFormatted.toLocaleString('en-US', {
                hour12: false, // Use 24-hour format
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });

            const saved = CartItem.reduce((sum, item) => sum + Math.round(Number(item.details.mrp) - Number(item.details.price)) * item.qty, 0);
            const savingsValue = JSON.stringify(appliedCoupon) === '{}' ? saved : saved + appliedCoupon.discountPrice;

            const couponCode = JSON.stringify(appliedCoupon) === '{}' ? null : appliedCoupon

            const dataToSend = {
                cartItem: CartItem,
                orderTotal: totalValue,
                savingsValue: savingsValue,
                address: {
                    address: selectedAddress.address,
                    positionCoords: selectedAddress.positionCoords,
                    type: 'home'
                },
                orderNumber: orderNumber,
                positionCoords: selectedAddress.positionCoords,
                orderTime: orderTime,
                status: 'Placed',
                userId: userId,
                couponCode: couponCode,
                couponDiscount: appliedCoupon.discountPrice,
                deliveryFee: deliverCharge,
                merchantId: 'default'
            }

            fetch(`${BACKEND_URL}/add-orders`, {
                method: 'post',
                headers: {
                    'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                    'content-type': 'application/json'
                },
                body: JSON.stringify(dataToSend),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data)
                    if (data.success === false) {
                        setError(true)
                        setTimeout(() => {
                            navigate('/');
                        }, 3000);

                    } else {
                        //removing cart items
                        clearCart();
                        setTimeout(() => {
                            navigate('/order-confirmed')
                        }, 2000)
                    }

                }).catch((error) => {
                    console.log(error)
                    setError(true)
                    setTimeout(() => {
                        navigate('/');
                    }, 3000);

                }).finally(
                    setLoading(true)
                )
        }
    }

    if (error) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <img src='/brand-icons/freslo-full-icon.png' alt='freslo logo' style={{ width: '220px', height: 'auto' }}></img>
                <p style={{ fontSize: '24px', fontWeight: 'bold', fontFamily: 'Arial', color: 'rgba(227, 47, 47, 0.927)' }}>Something went Wrong!</p>
            </div>
        );
    }

    if (loading) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <img className='loading-img' src='/brand-icons/freslo-full-icon.png' alt='freslo logo' style={{ width: '220px', height: 'auto', marginBottom: '30px' }}></img>
                <p style={{ fontSize: '24px', fontWeight: 'bold', fontFamily: 'Arial', color: '#2c5f2d' }}>Placing Your Order...</p>
            </div>
        );
    }

    return (
        <>
            <HeaderOther title='Payment' description='Secure checkout'/>
            <div className='container-pay'>
                <div className='payment-box'>
                    <p className='payment-mode'>Cash On delivery (COD)</p>
                    <input
                        type='radio'
                        value='Cash On delvery (COD)'
                        checked={selectedOption === 'Cash On delvery (COD)'}
                        onChange={handleChange}
                        className='radio-btn'
                    />
                </div>
                <div className='cart-bottom-payment-btn-style'>
                    <div className='cart-bottom-btns' onClick={placeOrder} >Place Order</div>
                </div>
            </div>
        </>
    );
}


